import { CookieBanner } from './cookie-banner';

export default CookieBanner;
